import { useEffect } from 'react';

export default function ScrollRestorer() {
  
  useEffect(() => {
    const handleMapLoaded = () => {
      const scrollY = localStorage.getItem('scrollY');
      if (scrollY !== null) {
        // Wait 100ms before scrolling
        setTimeout(() => {
          window.scrollTo(0, parseInt(scrollY, 10));
          localStorage.removeItem('scrollY');
          console.log('[ScrollRestorer] Scroll restored to', scrollY);
        }, 100);
      }
    };

    window.addEventListener('map-loaded', handleMapLoaded);
    
    // Clean up event listener when component is unmounted
    return () => window.removeEventListener('map-loaded', handleMapLoaded);
  }, []);

  return null;
}